import { Text } from '@epam/promo';
import noDataImage from 'assets/icons/no-data.svg';
import css from './StatisticsNoData.module.scss';

export const StatisticsNoData = () => (
  <div className={css['statistics-tasks__no-data']}>
    <img alt="No data to display" src={noDataImage} />
    <Text size="42">No data to display</Text>
  </div>
);
